import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface InvalidationDialogProps {
  open: boolean;
  affectedCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Riproduce il dialog "ATTENZIONE!" del legacy (WarningContent in
 * InfoPopup.jsx): avvisa che confermando la scelta corrente alcune risposte
 * successive verranno invalidate (qui: `toDeleteIds` dalla dryRun del BE).
 */
export function InvalidationDialog({
  open,
  affectedCount,
  onCancel,
  onConfirm,
}: InvalidationDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="invalidation-dialog-title">
      <DialogTitle
        id="invalidation-dialog-title"
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <WarningAmberIcon color="error" />
        Attenzione
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 1 }}>
          Modificando questa scelta verranno annullate anche{' '}
          {affectedCount === 1 ? 'la risposta successiva già data' : `${affectedCount} risposte successive già date`}.
        </Typography>
        <Typography variant="body2" fontWeight={600}>
          Vuoi comunque procedere con la modifica?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} color="inherit">
          No, mantengo le mie scelte
        </Button>
        <Button onClick={onConfirm} variant="contained" color="secondary" autoFocus>
          Sì, modifico questa scelta
        </Button>
      </DialogActions>
    </Dialog>
  );
}
